import apiCalls from "src/api/apiCalls";
import BalancesKpi from "./balanceKpi";
import CardsTopUpGraph from "./cardTopUpGraph";
import MerchantGraph from "./merchantGraph";
import ActiveCardsGraphs from "./activeCardsGraphs";
import AllStatesCards from "./allStatesCards";
import KPI from "./kpi";
import ProgramGraph from "./programGraphs";
import { useCallback, useEffect, useState } from "react";
import Loader from "src/components/loader.component";
import { Alert } from "antd";
const Cards = () => {
    const [programList, setProgramList] = useState([])
    const [loader, setLoader] = useState(false)
    const [error, setError] = useState(null)
    useEffect(() => {
        getProgramsList()
    }, [])
    const getProgramsList = async () => {
        setLoader(true);
        setError(null);

        try {
            const response = await apiCalls.getPrograms();
            if (response.status === 200) {
                setProgramList(response.data);
            } else {
                setProgramList([]);
                setError(apiCalls.isErrorDispaly(response));
            }
        } catch (err) {
            setProgramList([]);
            setError(apiCalls.isErrorDispaly(err));
        } finally {
            setLoader(false);
        }
    };
    const closeError = useCallback(() => {
        setError(null)
    }, [])
    const renderCharts = () => {
        return (
            <div className="grid md:grid-cols-2 gap-x-5 mt-7 max-sm:overflow-auto">
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>Active Card Progress</h3>
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>Card Status</h3>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section mb-6">
                        <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>Active Card Progress</h3>
                        <ActiveCardsGraphs />
                    </div>
                </div>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section mb-6">
                        <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>Card Status</h3>
                        <AllStatesCards />
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="">
            <div className="grid md:grid-cols-3 gap-5">
                <BalancesKpi />
            </div>
            <div className="mt-7">
                <KPI />
            </div>
            <div className="grid md:grid-cols-2 gap-5 mt-7">
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <h3 className='text-lg font-medium text-subTextColor mb-1.5'>Account Balance Topup</h3>
                    <MerchantGraph />
                </div>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <h3 className='text-lg font-medium text-subTextColor mb-1.5'>Card Topup</h3>
                    <CardsTopUpGraph />
                </div>
            </div>
            {renderCharts()}
            {loader && <Loader />}
            {error && <Alert className='mb-6 mt-7' description={error} type="error" onClose={closeError} showIcon closable />}
            {!loader && <div className="grid md:grid-cols-2 gap-5 mt-7">
                {programList?.map((item) => (<div key={item.id}>
                    <h3 className='text-lg font-medium text-subTextColor mb-1.5'>{item.programName}</h3>
                    <div className="border bg-chartimg !border-cardBorder rounded-md p-2 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                        <ProgramGraph program={item} />
                    </div>
                </div>))}
            </div>}
        </div>
    )
}
export default Cards